"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import { useFormControlPrivate } from "./FormControl.context.js";
import FormControlCaption from "./FormControlCaption.js";
const FormControlHelper = (props) => {
    const { children } = props;
    const { disabled } = useFormControlPrivate();
    return _jsx(FormControlCaption, { disabled: disabled, children: children });
};
FormControlHelper.displayName = "FormControl.Helper";
export default FormControlHelper;
